module.exports = __webpack_public_path__ + "img/chpc_home_about.9e39dbc0.jpg";